import React from 'react';
import { ShowButton, SelectInput, Filter, Datagrid, TextField, DateField } from 'react-admin';
import AmountField from '../../components/fields/AmountField';
import TList from '../../components/wrapper/TList';
import PaymentFailureListActions from './PaymentFailureListActions';
import {
	coreWalletPaymentFailureStatusForSelection,
	coreWalletPaymentFailureTypesForSelection
} from './PaymentFailureConstants';

const PaymentFailuresFilter = ({ walletAccountTypesForSelection, ...props }) => (
	<Filter {...props}>
		<SelectInput
			alwaysOn
			resettable
			label="resources.paymentFailures.filter.type"
			source="paymentFailureType"
			choices={coreWalletPaymentFailureTypesForSelection}
		/>
		<SelectInput
			alwaysOn
			resettable
			label="resources.paymentFailures.filter.status"
			source="paymentFailureStatus"
			choices={coreWalletPaymentFailureStatusForSelection}
		/>
	</Filter>
);

const PaymentFailureList = props => (
	<TList
		{...props}
		sort={{ field: 'creationDateTime', order: 'DESC' }}
		actions={<PaymentFailureListActions />}
		filters={<PaymentFailuresFilter />}
	>
		<Datagrid>
			<ShowButton />
			<TextField source="id" />
			<DateField source="creationDateTime" showTime />
			<AmountField source="amount" sortable={false} />
			<TextField source="paymentFailureType" sortable={false} />
			<TextField source="paymentFailureStatus" sortable={false} />
			<TextField source="description" />
			<TextField source="externalReferenceId" />
		</Datagrid>
	</TList>
);

export default PaymentFailureList;
